/**
 * /api-keys — platform-scoped route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchApiKeys } from "@/features/api-keys/queries";
import { queryKeys } from "@/lib/query-keys";
import { ApiKeysPage } from "@/features/api-keys/pages/api-keys-page";

export const Route = createFileRoute("/_authed/api-keys/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.apiKeys.list,
      queryFn: fetchApiKeys,
    }),
  component: ApiKeysPage,
});
